import React from 'react';
import { Notification } from '@honeycomb-npm/honeycomb-react';

function Info() {
    return (
        <div className="row mx-0" aria-label="notification">
            <Notification type="info" isOpen heading="Keep in mind">
                We rely on other banks to share tracking details and some don’t support tracking.
                The status of your payment may not be available or up to date.
            </Notification>
        </div>
    );
}
export default Info;
